/* Keep this in sync with bootstrap/variables.less */

import {Color} from '@benchling/nucleus-ui';

import {assert} from 'Asserts';

export const NEAR_BLACK = Color.GRAY_900;
export const GRAY_DARKER = Color.GRAY_700;
export const GRAY_SEMIDARK = Color.GRAY_600;
export const GRAY_DARK = Color.GRAY_400;
export const GRAY = Color.GRAY_300;
export const GRAY_LIGHT = Color.GRAY_200;
export const GRAY_LIGHTER = Color.GRAY_50;
export const WHITE = '#FFFFFF';

// Brand colors

export const BLUE_POWDER_LIGHT = Color.BLUE_100;
export const BLUE_POWDER = Color.BLUE_100;
export const BLUE_LIGHTEST = Color.BLUE_200;
export const BLUE_LIGHTER = Color.BLUE_300;
export const BLUE_LIGHT = Color.BLUE_400;
export const BLUE_LIGHT_DISABLED = Color.BLUE_200;
export const BLUE = Color.BLUE_500;
export const BLUE_DARKER = Color.BLUE_600;

export const RED_POWDER = Color.RED_100;
export const RED_LIGHTEST = Color.RED_150;
export const RED_LIGHTER = Color.RED_200;
export const RED_LIGHT = Color.RED_400;
export const RED = Color.RED_500;
export const RED_DARK = Color.RED_600;
export const RED_DARKER = '#600000';

export const ORANGE_LIGHTEST = Color.ORANGE_100;
export const ORANGE_LIGHTER = Color.ORANGE_200;
export const ORANGE_POWDER = Color.ORANGE_300;
export const ORANGE_LIGHT = Color.ORANGE_350;
export const ORANGE = Color.ORANGE_400;
export const ORANGE_DARK = Color.ORANGE_500;
export const ORANGE_DARKER = Color.ORANGE_600;

export const YELLOW_LIGHTEST = Color.YELLOW_100;
export const YELLOW_LIGHTER = Color.YELLOW_200;
export const YELLOW_LIGHT = Color.YELLOW_300;
export const YELLOW = Color.YELLOW_400;
export const YELLOW_DARK = Color.YELLOW_500;
export const YELLOW_DARKER = Color.YELLOW_600;

export const GREEN_LIGHTEST = Color.GREEN_100;
export const GREEN_LIGHTER = Color.GREEN_200;
export const GREEN_LIGHT = Color.GREEN_300;
export const GREEN = Color.GREEN_400;
export const GREEN_DARK = Color.GREEN_500;
export const GREEN_DARKER = Color.GREEN_600;

export const PURPLE_LIGHTEST = Color.PURPLE_100;
export const PURPLE_LIGHTER = Color.PURPLE_200;
export const PURPLE_LIGHT = Color.PURPLE_300;
export const PURPLE = Color.PURPLE_400;
export const PURPLE_DARK = Color.PURPLE_500;

export const CLOUDS = Color.BRAND_ICE;
export const PETER_RIVER = Color.TEAL_400;
export const SILVER = Color.GRAY_500;
export const POMEGRANATE = Color.FUCHSIA_500;
export const LIME = Color.LIME_300;
export const EMERALD = Color.GREEN_600;
export const AMETHYST = Color.PURPLE_400;
export const WISTERIA = Color.PURPLE_300;

export function hexToRgbObject(hex: string): {r: number; g: number; b: number} {
  assert(hex.match(/^#?[a-fA-F\d]{6}$/) != null, 'Invalid hex string provided');
  const [r, g, b] = hex.match(/[a-fA-F\d]{2}/g)!.map((x) => parseInt(x, 16));
  return {r, g, b};
}

/**
 * Convert 6-digit hex string to RGBA color.
 * Example usage:  boxShadow: `0px 2px 6px 0px rgba(${hexToRgba(GRAY, 0.7)})`,
 * @link https://stackoverflow.com/a/51564734 (modified)
 */
export function hexToRgba(hex: string, alpha: number = 1): string {
  assert(alpha >= 0 && alpha <= 1, 'Alpha must be between 0 and 1');
  assert(hex.match(/^#?[a-fA-F\d]{6}$/) != null, 'Invalid hex string provided');
  const [r, g, b] = hex.match(/[a-fA-F\d]{2}/g)!.map((x) => parseInt(x, 16));
  return `${r}, ${g}, ${b}, ${alpha}`;
}

/**
 * Convert 6-digit hex string to RGB color.
 * Example: hexToRgb('#FFFFFF') === '255, 255, 255'
 */
export function hexToRgb(hex: string): string {
  const {r, g, b} = hexToRgbObject(hex);
  return `${r}, ${g}, ${b}`;
}
